import React from "react";
import videoSrc from "../Images/VideoExplainAutocreateApps.mp4"; // adjust the path and filename

export default function ExplainVideo() {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "600px",
        margin: "0 auto",
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      <video
        style={{
          width: "100%",
          height: "auto",
          borderRadius: "8px",
        }}
        controls
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
